export class UnsupportedBrowserError extends Error {}

export class MaintenanceError extends Error {}
